import React from 'react';
import '../style.css';

class Home extends React.Component {
    render() {
        return (
            <div className="modern-home" id="home">
                {/* Hero Section */}
                <div className="hero-section">
                    <div className="hero-content">
                        <div className="hero-badge">
                            <span>👋 Welcome to my portfolio</span>
                        </div>
                        
                        <h1 className="hero-title">
                            Hi, I'm <span className="name-highlight">Dhruvin</span>
                        </h1>
                        
                        <h2 className="hero-subtitle">
                            Software Engineer | Frontend Developer | AI Enthusiast
                        </h2>
                        
                        <p className="hero-description">
                            Software Engineer with 5+ years of architecting scalable mission-critical single-page applications. Proven leadership in defining code standards, ensuring correctness in high-stakes environments, and
delivering complex products that champion customer needs. Expertise building extensible design systems, optimizing
frontend architecture, and leading cross-functional teams to deliver production-grade solutions with meticulous quality
standards.
                        </p>

                        <div className="hero-buttons">
                            <a href="#about" className="btn-primary">
                                Learn More About Me
                                <span className="btn-arrow">→</span>
                            </a>
                            {/* <a href="#blog" className="btn-secondary">
                                View My Blogs
                            </a> */}
                        </div>
                    </div>

                    {/* Decorative Elements */}
                    <div className="hero-decoration">
                        <div className="decoration-circle circle-1"></div>
                        <div className="decoration-circle circle-2"></div>
                        <div className="decoration-circle circle-3"></div>
                    </div>
                </div>

                {/* Scroll Indicator */}
                <div className="scroll-indicator">
                    <div className="scroll-text">Scroll Down</div>
                    <div className="scroll-arrow">↓</div>
                </div>
            </div>
        )
    }
}

export default Home;